import { useState } from 'react'

import { useCloseModal, useModalController, useConfigureModalController } from '@/atoms'

type ModalState = 'ready' | 'submitting'
interface ModalData {
  tenantSource: uui.domain.server.gps.telematics.TenantSource
  source: uui.domain.server.gps.telematics.Source
}

export const modalId = 'editTenantSourceCredentials'

export const useController = () => useModalController<ModalData, ModalState>(modalId)
export const useConfigureController = (
  tenantSource: uui.domain.server.gps.telematics.TenantSource,
  source: uui.domain.server.gps.telematics.Source,
) => {
  const close = useCloseModal()

  // INITIALIZATION

  const [options] = useState(() => ({
    createInitialState: () => ({
      close,
      data: {
        tenantSource,
        source,
      },
    }),
  }))

  return useConfigureModalController<ModalData, ModalState>(modalId, options)
}
